export const TemplateApplication = {
    path: '/template_applications',
    name: 'template_applications',
    component: () => import('@/views/Edms/TemplateApplication/TemplateApplicationPage.vue'),
}